import Dashboard from "../Screens/Dashboard/Dashboard";
import Users from "../Screens/Users/Users";
import UserDetails from "../Screens/Users/UserDetails";
import Ledgers from "../Screens/Users/Ledgers";
import Transfers from "../Screens/Transfers/Transfers";
import PlatformBalance from "../Screens/PlatformBalance/PlatformBalance";
import AssetDetailsPage from "../Screens/PlatformBalance/AssetDetailsPage";
import AutoTransfers from "../Screens/Transfers/AutoTransfers";
import FeesManagement from "../Screens/FeesManagment/FeesManagement";
import TradeFees from "../Screens/FeesManagment/TradeFees";
import SystemLedger from "../Screens/SystemLedger/SystemLedger";
import UserActivity from "../Screens/Transfers/UserActivity";
import AssetManagement from "../Screens/AssetManagement/AssetManagement";
import Transactions from "../Screens/Transactions/Transaction";
import ReferralSummary from "../Screens/Referrals/ReferralSummary";
import IncompleteOnboardingUsers from "../Screens/IncompleteOnboardingUsers/IncompleteOnboardingUsers";
import Referrals from "../Screens/Referrals/Referrals";
import Settings from "../Screens/Settings/Settings";
import UserSpinHistory from "../Screens/Referrals/Userspinhistory";
import SpinLogs from "../Screens/Referrals/SpinLogs";
import SpinSequenceMonitor from "../Screens/Referrals/SpinSequenceMonitor";
import AuditLogs from "../Screens/AuditLogs/AuditLogs";
import Notifications from "../Screens/Notifications/Notifications";
import NewCampaign from "../Screens/Notifications/NewCampaign";
import CampaignDetail from "../Screens/Notifications/CampaignDetail";
import Groups from "../Screens/Groups/Groups";
import GroupDetail from "../Screens/Groups/GroupDetail";
import CountriesPage from "../Screens/Countries/CountriesPage";

export const routeConfig = [
  {
    path: "/admin/dashboard",
    element: <Dashboard />,
    title: "Dashboard",
    isPrivate: true,
  },
  {
    path: "/admin/users",
    element: <Users />,
    title: "Users",
    isPrivate: true,
  },
  {
    path: "/admin/users/userDetails",
    element: <UserDetails />,
    title: "User Details",
    isPrivate: true,
  },
  {
    path: "/admin/users/ledgers",
    element: <Ledgers />,
    title: "Ledgers",
    isPrivate: true,
  },
  {
    path: "/admin/transfers",
    element: <Transfers />,
    title: "Transfers",
    isPrivate: true,
  },
  {
    path: "/admin/platform-balance",
    element: <PlatformBalance />,
    title: "Platform Balance",
    isPrivate: true,
  },
  {
    path: "/admin/platform-balance/:currency",
    element: <AssetDetailsPage />,
    title: "Asset Details",
    isPrivate: true,
  },
  {
    path: "/admin/auto-transactions",
    element: <AutoTransfers />,
    title: "Auto Transactions",
    isPrivate: true,
  },
  {
    path: "/admin/fees-management",
    element: <FeesManagement />,
    title: "Fees Management",
    isPrivate: true,
  },
  {
    path: "/admin/trade-fees",
    element: <TradeFees />,
    title: "Trade Fees",
    isPrivate: true,
  },
  {
    path: "/admin/system-ledger",
    element: <SystemLedger />,
    title: "System Ledger",
    isPrivate: true,
  },
  {
    path: "/admin/user-activity",
    element: <UserActivity />,
    title: "User Activity",
    isPrivate: true,
  },
  {
    path: "/admin/asset-management",
    element: <AssetManagement />,
    title: "Asset Management",
    isPrivate: true,
  },
  {
    path: "/admin/transactions",
    element: <Transactions />,
    title: "Transactions",
    isPrivate: true,
  },
  {
    path: "/admin/referral-summary",
    element: <ReferralSummary />,
    title: "Referral Summary",
    isPrivate: true,
  },
  {
    path: "/admin/incomplete-onboarding-users",
    element: <IncompleteOnboardingUsers />,
    title: "Incomplete Users",
    isPrivate: true,
  },
  {
    path: "/admin/referrals",
    element: <Referrals />,
    title: "Referrals",
    isPrivate: true,
  },
  {
    path: "/admin/settings",
    element: <Settings />,
    title: "Settings",
    isPrivate: true,
  },
  {
    path: "/admin/user-spin-history",
    element: <UserSpinHistory />,
    title: "User Spin History",
    isPrivate: true,
  },
  {
    path: "/admin/spin-logs",
    element: <SpinLogs />,
    title: "Spin Logs",
    isPrivate: true,
  },
  {
    path: "/admin/spin-sequence-monitor",
    element: <SpinSequenceMonitor />,
    title: "Spin Sequence Monitor",
    isPrivate: true,
  },
  {
    path: "/admin/audit-logs",
    element: <AuditLogs />,
    title: "Audit Logs",
    isPrivate: true,
  },
  {
    path: "/admin/notifications",
    element: <Notifications />,
    title: "Notifications",
    isPrivate: true,
  },
  {
    path: "/admin/notifications/new",
    element: <NewCampaign />,
    title: "New Campaign",
    isPrivate: true,
  },
  {
    path: "/admin/notifications/:id",
    element: <CampaignDetail />,
    title: "Campaign Details",
    isPrivate: true,
  },
  {
    path: "/admin/groups",
    element: <Groups />,
    title: "Groups",
    isPrivate: true,
  },
  {
    path: "/admin/groups/:id",
    element: <GroupDetail />,
    title: "Group Details",
    isPrivate: true,
  },
  {
    path: "/admin/countries",
    element: <CountriesPage />,
    title: "Countries",
    isPrivate: true,
  },
];
